import { createElement } from 'react';
const Container = function Container({ style = {}, isPageContainer = false, top = 103, ...otherProps }) {
    const pageStyle = isPageContainer
        ? {
            width: '100%',
            height: `calc(100vh - ${top}px)`,
            backgroundColor: '#edeff3',
            padding: '20px',
            overflow: 'auto',
        }
        : {};
    const _style = style || {};
    const _otherProps = otherProps || {};
    _otherProps.style = Object.assign(pageStyle, _style);
    const { children, ...rest } = _otherProps;
    return createElement("div", { ...rest }, children);
};
Container.displayName = 'Container';
export default Container;
